import { render, staticRenderFns } from "./recuInput.vue?vue&type=template&id=6f6f8062&scoped=true"
import script from "./recuInput.vue?vue&type=script&lang=js"
export * from "./recuInput.vue?vue&type=script&lang=js"
import style0 from "./recuInput.vue?vue&type=style&index=0&id=6f6f8062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6f8062",
  null
  
)

export default component.exports